// extracted by mini-css-extract-plugin
export var productImage = "_zc-0";